export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0033.ada32e30.webp";